import { render, staticRenderFns } from "./compClubConfig.vue?vue&type=template&id=7432e664&scoped=true&"
import script from "./compClubConfig.vue?vue&type=script&lang=js&"
export * from "./compClubConfig.vue?vue&type=script&lang=js&"
import style0 from "./compClubConfig.vue?vue&type=style&index=0&id=7432e664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432e664",
  null
  
)

export default component.exports